import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Project from "./components/Project";
import Skills from "./components/Skills";
import About from "./components/About";
import Contact from "./components/Contact";
import Showcase from "./components/showcase";
import "./App.css"

function App() {  
  return (
    <Router>
      <Navbar />
      <div className="container mt-5 pt-5">
        <Routes>
           <Route path="/" element={<About />} />
          <Route path="/about" element={<About />} />
          <Route path="/project" element={<Project />} />
          <Route path="/skills" element={<Skills />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/showcase" element={<Showcase />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
